/**
 * @generated SignedSource<<a40b4e1702f5f20e07a5a1fac22f77ba>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type ImportExistingTicketPaneTicketQuery$variables = {
  taskId: string;
  workspaceId?: string | null;
};
export type ImportExistingTicketPaneTicketQuery$data = {
  readonly viewer: {
    readonly integrations: {
      readonly clickup: {
        readonly task: {
          readonly externalId: string;
          readonly id: string;
          readonly name: string;
        } | null;
      } | null;
    };
  };
};
export type ImportExistingTicketPaneTicketQuery = {
  response: ImportExistingTicketPaneTicketQuery$data;
  variables: ImportExistingTicketPaneTicketQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "taskId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "workspaceId"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": [
    {
      "kind": "Variable",
      "name": "taskId",
      "variableName": "taskId"
    },
    {
      "kind": "Variable",
      "name": "workspaceId",
      "variableName": "workspaceId"
    }
  ],
  "concreteType": "ClickupTaskNode",
  "kind": "LinkedField",
  "name": "task",
  "plural": false,
  "selections": [
    (v1/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "externalId",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ImportExistingTicketPaneTicketQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "UserIntegrations",
            "kind": "LinkedField",
            "name": "integrations",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ClickupUserNode",
                "kind": "LinkedField",
                "name": "clickup",
                "plural": false,
                "selections": [
                  (v2/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ImportExistingTicketPaneTicketQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "UserIntegrations",
            "kind": "LinkedField",
            "name": "integrations",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ClickupUserNode",
                "kind": "LinkedField",
                "name": "clickup",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v1/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v1/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "bb13f48c6ca64211bf4eb81f89b5e1a8",
    "id": null,
    "metadata": {},
    "name": "ImportExistingTicketPaneTicketQuery",
    "operationKind": "query",
    "text": "query ImportExistingTicketPaneTicketQuery(\n  $taskId: String!\n  $workspaceId: String\n) {\n  viewer {\n    integrations {\n      clickup {\n        task(taskId: $taskId, workspaceId: $workspaceId) {\n          id\n          name\n          externalId\n        }\n        id\n      }\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "b79584e55da0a76c23305c1a248dfe82";

export default node;
